export const REQUEST_SUBMIT_FORM = 'REQUEST_SUBMIT_FORM'
export const RECEIVE_SUBMIT_FORM = 'RECEIVE_SUBMIT_FORM'

export const requestSubmitForm = data => {
  return {
    type: REQUEST_SUBMIT_FORM,
    data,
  }
}

export const receiveSubmitForm = data => {
  return {
    type: RECEIVE_SUBMIT_FORM,
    data,
  }
}
